import React from 'react';
import { Link } from 'react-router';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { Button } from '../../../components/Button';
import { IconWrap } from '../../../components/IconWrap';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';
import { CiBatteryFull, CiDroplet } from 'react-icons/ci';
import { BiBuildings, BiCog } from 'react-icons/bi';

interface SectorsPreviewProps {
    index?: number;
}

export const SectorsPreview: React.FC<SectorsPreviewProps> = ({ index }) => {
    const { theme, breakpoint } = useTheme();
    const sectors = megaGreenData.sectors.sectors.slice(0, 4); // Show first 4

    return (
        <Section index={index}>
            <h2
                style={{
                    fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                    fontWeight: 700,
                    color: theme.text.primary,
                    marginBottom: '48px',
                }}
            >
                Sectors we support
            </h2>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : breakpoint.md ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: '24px',
                    marginBottom: '32px',
                }}
            >
                {sectors.map((sector, idx) => {
                    const sectorIcons = [
                        <BiCog />, // Manufacturing/Industrial
                        <CiBatteryFull />, // Energy
                        <BiBuildings />, // Infrastructure
                        <CiDroplet />, // Water/Wastewater
                    ];
                    const iconColors: Array<'primary' | 'secondary' | 'accent' | 'highlight' | 'feature'> = [
                        'primary',
                        'secondary',
                        'accent',
                        'highlight',
                    ];

                    return (
                        <Card key={sector.id} hoverable>
                            <IconWrap
                                icon={sectorIcons[idx] || <BiCog />}
                                size={32}
                                color={iconColors[idx] || 'primary'}
                                withBackground={true}
                                style={{ marginBottom: '16px' }}
                            />
                            <h3
                                style={{
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: theme.text.primary,
                                    marginBottom: '8px',
                                }}
                            >
                                {sector.title}
                            </h3>
                            <p
                                style={{
                                    fontSize: '14px',
                                    color: theme.text.muted,
                                    lineHeight: 1.5,
                                }}
                            >
                                {sector.short}
                            </p>
                        </Card>
                    );
                })}
            </div>

            <div style={{ textAlign: 'center' }}>
                <Link to="/sectors" style={{ textDecoration: 'none' }}>
                    <Button variant="secondary">View all sectors</Button>
                </Link>
            </div>
        </Section>
    );
};

